// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.CredentialIssuerSettings
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.wallet.shared.CredentialIssuerSettingsAndroidKeySettings
import org.multipaz.wallet.shared.CredentialIssuerSecureAreaType
import org.multipaz.wallet.shared.toDataItem
import org.multipaz.wallet.shared.fromDataItem

fun CredentialIssuerSettings.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "v28j6Ntjz9S85OdZAx5qgdqaMfrs854aVn4q6NipkYU")
val CredentialIssuerSettings_cborSchemaId = ByteString(-65, 111, 35, -24, -37, 99, -49, -44, -68, -28, -25, 89, 3, 30, 106, -127, -38, -102, 49, -6, -20, -13, -98, 26, 86, 126, 42, -24, -40, -87, -111, -123)

fun CredentialIssuerSettings.Companion.fromCbor(data: ByteArray): CredentialIssuerSettings {
    return CredentialIssuerSettings.fromDataItem(Cbor.decode(data))
}

val CredentialIssuerSettings.Companion.cborSchemaId: ByteString
    get() = CredentialIssuerSettings_cborSchemaId

fun CredentialIssuerSettings.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("secureAreaToUse", Tstr(this.secureAreaToUse.name))
    val androidKeySettings = this.androidKeySettings
    if (androidKeySettings != null) {
        builder.put("androidKeySettings", androidKeySettings.toDataItem())
    }
    return builder.end().build()
}

fun CredentialIssuerSettings.Companion.fromDataItem(dataItem: DataItem): CredentialIssuerSettings {
    val secureAreaToUse = CredentialIssuerSecureAreaType.valueOf(dataItem["secureAreaToUse"].asTstr)
    val androidKeySettings0 = if (dataItem.hasKey("androidKeySettings")) {
        CredentialIssuerSettingsAndroidKeySettings.fromDataItem(dataItem["androidKeySettings"])
    } else {
        null
    }
    return CredentialIssuerSettings(
        secureAreaToUse = secureAreaToUse,
        androidKeySettings = androidKeySettings0,
    )
}
